var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('main-visual'), _c('main-efficient', {
    attrs: {
      "lang": "en"
    }
  }), _c('main-practice-areas', {
    attrs: {
      "lang": "en"
    }
  }), _c('main-attorneys', {
    attrs: {
      "lang": "en"
    }
  }), _c('main-location', {
    attrs: {
      "lang": "en"
    }
  }), _c('popup-layer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }